export default __webpack_public_path__ + "static/media/coalitionblackwomen.54dbf0cf.png";